export const importantInfo = '#F2994A';

export default {
  importantInfo,
};
